import { useMemo } from 'react';
import { useDefaultAccountsActions } from '#/preferences/default-accounts/context';
import { useAccounts } from '#/unified-rfqs/contexts/accounts';
import { AccountResponse } from '@paradigm/api/src/accounts';
import { Maybe } from '@paradigm/utils/types';
import { Source } from '#/unified-rfqs/entities/products/venue';
import { useDefaultAccountsFeatureFlag } from '#/feature-flags/context';

export default function useAccountsWithDefault(
  venue: string,
  productCode: Maybe<string>,
): AccountResponse[] {
  const accounts = useAccounts();
  const { getDefaultAccount } = useDefaultAccountsActions();
  const defaultAccount = getDefaultAccount(venue as Source, productCode);
  const isDefaultAccountsEnabled = useDefaultAccountsFeatureFlag();

  return useMemo(() => {
    const venueAccounts = [...accounts.selectByVenue(venue as Source)];
    if (!isDefaultAccountsEnabled) return venueAccounts;

    return venueAccounts.map((acc) => ({
      ...acc,
      is_default: acc.name === defaultAccount,
    }));
  }, [accounts, defaultAccount, isDefaultAccountsEnabled, venue]);
}
